import config from "../config.json"

const user = {
  loginUser(data){
    return fetch(`${config.postRequest.url}login.php?email=${data.get("email")}&passwd=${data.get("passwd")}`)
      .then(function (res) {
        return res.json();
      })
  },
  getUser(id){
    return fetch(`${config.apiUrl}customers/${id}&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      }).then(d => {
        return d.customer;
      })
  },
  registration(data){
    return fetch(`${config.postRequest.url}addCustomer.php?` +
      `${data.get("id")=== null ? `` : `id=${data.get("id")}&`}` +
      `email=${data.get("email")}&passwd=${data.get("passwd")}` +
      `&lastname=${data.get("lastname")}&firstname=${data.get("firstname")}` +
      `${data.get("birthday") === "" ? `` : `&birthday=${data.get("birthday")}`}` +
      `${data.get("id_gender") === null ? `` : `&id_gender=${data.get("id_gender")}`}` +
      `${data.get("optin") === null ? `` : `&optin=${data.get("optin")}`}` +
      `${data.get("newsletter") === null ? `` : `&newsletter=${data.get("newsletter")}`}`
    )
      .then(function (res) {
        return res.json();
      })
  },
  getAddresse(id){
    return fetch(`${config.apiUrl}/addresses/` +
      `?display=[id,id_customer,alias,company,lastname,firstname,city,address1,phone,vat_number,postcode]` +
      `&filter[id_customer]=[${id}]` +
      `&ws_key=${config.apiKey}&${config.dataType}`)
      .then(function (response) {
        return response.json();
      }).then(d => {
        return d.addresses;
      })
  },
  forgotUsers(data){
    return fetch(`${config.postRequest.url}addForgotPassword.php?` +
      `${data.get("email")=== null ? `` : `email=${data.get("email")}`}`
    )
    .then(function (res) {
        return res.json();
    })
  },
  ChangePasswordtUsers(data){
    return fetch(`${config.postRequest.url}addChangePasswords.php?` +
    `${data.get("email")=== null ? `` : `email=${data.get("email")}&`}` +
    `passwd=${data.get("newPassword")}`
    )
    .then(function (res) {
        return res.json();
    })
  },
  
}

export default user;


// WEBPACK FOOTER //
// ./src/utils/user/index.js